/**
 * @generated SignedSource<<4d47195ec7a9928faf97593af0abe3ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StoreCustomMetricInput = {
  componentName?: string | null;
  metricName?: string | null;
  value?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StoreCustomMetricMutation$variables = {
  input: StoreCustomMetricInput;
};
export type StoreCustomMetricMutation$data = {
  readonly storeCustomMetric: {
    readonly clientMutationId: string | null;
  } | null;
};
export type StoreCustomMetricMutation = {
  variables: StoreCustomMetricMutation$variables;
  response: StoreCustomMetricMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StoreCustomMetricPayload",
    "kind": "LinkedField",
    "name": "storeCustomMetric",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreCustomMetricMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreCustomMetricMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94376ab9fa1b1cbd9d70e00341eeb3ea",
    "id": null,
    "metadata": {},
    "name": "StoreCustomMetricMutation",
    "operationKind": "mutation",
    "text": "mutation StoreCustomMetricMutation(\n  $input: StoreCustomMetricInput!\n) {\n  storeCustomMetric(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab756db76024b3a54570b52c88220899";

export default node;
